import { Box, BoxProps, Stack, styled } from "@mui/material"
import { ComponentType } from "react"
import { ImageStylings } from "./Image"

type ImageContainerProps = BoxProps & {
    imageStylings?: ImageStylings
}
export const ImageContainer = styled(Box, { shouldForwardProp: (prop: string) => !["imageStylings"].includes(prop) })<ImageContainerProps>(
    ({ theme, imageStylings }) => ({
        boxSizing: "border-box",
        border: `1px solid transparent`,
        backgroundColor: theme.palette.background.default,
        boxShadow: imageStylings?.boxShadow || "0 1px 5px rgb(0 0 0 / 20%);",
        width: imageStylings ? imageStylings.size : undefined,
        height: imageStylings ? imageStylings.size : undefined,
        zIndex: 2,
        marginTop: imageStylings ? `${imageStylings.marginTop}px` : undefined,
        "&[data-clickable]:hover": {
            borderColor: `${theme.palette.primary.main}`,
            cursor: "pointer",
        },
        img: {
            objectFit: "contain",
        },
        textAlign: "center",
        alignContent: "center",
    })
) as ComponentType<ImageContainerProps>

export const TileWrapper = styled(Stack, { shouldForwardProp: (prop) => prop !== "expanded" })<{ expanded: boolean }>(({ theme, expanded }) => ({
    height: "100%",
    justifyContent: "space-between",
    gap: "0.5em",
    padding: "0.5em",
    borderRadius: "3px",
    ...(expanded && { border: "1px solid", borderColor: theme.palette.primary.main, boxShadow: "0 4px 10px 0 rgb(0 0 0 / 20%)" }),
}))
